<div class="page-container">
  <div class="header-section">
    <lib-breadcrumb [list]="breadcrumbs()"></lib-breadcrumb>
    <h2 class="page-title">Court Staff Roles</h2>
  </div>

  <div class="content-wrapper" [class.blur]="loading">

    <form [formGroup]="searchFormGrp" (ngSubmit)="searchHandler()" class="search-form-card">
      <div class="search-grid">
        <div class="form-item">
          <mat-label>Court</mat-label>
          <mat-form-field appearance="outline" class="full-width">
            <mat-select formControlName="court" (selectionChange)="onCourtChange($event.value)">
              <mat-option>
                <ngx-mat-select-search [formControl]="courtFilterCtrl" placeholderLabel="Search..."
                  noEntriesFoundLabel="No results found">
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let court of filteredCourts | async" [value]="court">
                {{ court.name }}
              </mat-option>
            </mat-select>
            <div matSuffix *ngIf="isCourtLoading" style="margin-right: 8px; display: flex; align-items: center;">
              <mat-spinner diameter="20"></mat-spinner>
            </div>
          </mat-form-field>
        </div>

        <div class="form-actions">
          <button type="submit" mat-flat-button color="primary">Search</button>
        </div>

      </div>
    </form>
    <div class="section-container">
      <div class="section-header">
        <h3 class="heading">Court Staff Roles</h3>

        <div class="action-toolbar">
          <button mat-button color="primary"
            [disabled]="caseDataSource.data.length === 0 || (!isAddMode && !isEdit) || !hasMasterChanges()"
            (click)="getconfirmation('Save')">
            <mat-icon>save</mat-icon> Save
          </button>

          <button mat-button color="primary"
            [disabled]="selectedCourt===null || isAddMode || isEdit || selectedData.length===0"
            (click)="editdocument()">
            <mat-icon>edit</mat-icon> Modify
          </button>

          <button mat-button color="warn" *ngIf="isEdit || isAddMode" (click)="cancelEdit()">
            <mat-icon>cancel</mat-icon> Cancel
          </button>

          <button mat-button color="primary" [disabled]="isDashboard || isAddMode || isEdit || selectedData.length!==0 || selectedCourt===null"
            (click)="openModal()">
            <mat-icon>add</mat-icon> Add
          </button>

        </div>
      </div>

      <div class="responsive-table-wrapper">
        <div *ngIf="loading" style="display: flex; justify-content: center; align-items: center; height: 250px;">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
        <cdk-virtual-scroll-viewport *ngIf="!loading" itemSize="48" class="virtual-viewport main-table-viewport">
          <table mat-table [dataSource]="caseDataSource" matSort class="mat-elevation-z0">

            <ng-container *ngFor="let col of columnDefinitions" [matColumnDef]="col.column">
              <ng-container *ngIf="col.column !== 'select'; else noSortHeader">
                <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColumnStyle(col.column)">
                  {{ col.labels}}
                </th>
              </ng-container>
              <ng-template #noSortHeader>
                <th mat-header-cell *matHeaderCellDef [ngStyle]="getColumnStyle(col.column)">
                  {{ col.labels}}
                </th>
              </ng-template>

              <td mat-cell *matCellDef="let element" [ngStyle]="getColumnStyle(col.column)">
                <ng-container [ngSwitch]="col.column">
                  <mat-checkbox *ngSwitchCase="'select'" [checked]="selectedData.includes(element)"
                    (change)="onCheckboxChange(element, $event.checked)">
                  </mat-checkbox>
                  <span *ngSwitchCase="'staffId'">
                    <ng-container *ngIf="!element.isAddMode">{{element.prtId}}</ng-container>
                    <mat-form-field *ngIf="element.isAddMode" appearance="outline" class="dense-form-field"
                      style="margin-bottom: -1.25em;">
                      <mat-select [(ngModel)]="element.staffId"
                        (selectionChange)="onStaffIdChange($event.value, element)">
                        <mat-select-trigger>
                          {{element.staffId}}
                        </mat-select-trigger>
                        <mat-option>
                          <ngx-mat-select-search [formControl]="courtStaffFilterCtrl" placeholderLabel="Search Staff..."
                            noEntriesFoundLabel="No results found">
                          </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let staff of filtercourtStaffParties | async"
                          [value]="staff.prtId">{{staff.prtId}}
                          ({{staff.prtName}})</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </span>
                  <span *ngSwitchCase="'partyName'"> {{element.prtName}} </span>
                  <span *ngSwitchCase="'staffType'">
                    <ng-container *ngIf="!element.isAddMode && !element.isEditMode">{{element.stpName}}</ng-container>
                    <mat-form-field *ngIf="element.isAddMode || element.isEditMode" appearance="outline"
                      class="dense-form-field" style="margin-bottom: -1.25em;">
                      <mat-select [(ngModel)]="element.stpId"
                        (selectionChange)="onStaffTypeChange($event.value, element)">
                        <mat-option *ngIf="element.staffType && !isStaffTypeInList(element.staffType)"
                          [value]="element.staffType" style="display: none;">{{element.staffType}}</mat-option>
                        <mat-option *ngFor="let type of staffTypesList"
                          [value]="type.stpId">{{type.stpName}}</mat-option>
                      </mat-select>
                      <div matSuffix *ngIf="isStaffTypeLoading"
                        style="margin-right: 8px; display: flex; align-items: center;">
                        <mat-spinner diameter="20"></mat-spinner>
                      </div>
                    </mat-form-field>
                  </span>
                  <span *ngSwitchCase="'userActiveUntil'">
                    <ng-container *ngIf="!element.isAddMode && !element.isEditMode">
                      {{ element.userActiveUntil | date:'dd-MMM-yyyy' }}
                    </ng-container>

                    <mat-form-field *ngIf="element.isAddMode || element.isEditMode" appearance="outline"
                      class="dense-form-field" style="margin-bottom: -1.25em;">

                      <input matInput [matDatepicker]="uaPicker" [min]="minDate" [(ngModel)]="element.userActiveUntil"
                        (dateChange)="onDateSelected($event, element)">

                      <mat-datepicker-toggle matSuffix [for]="uaPicker"></mat-datepicker-toggle>
                      <mat-datepicker #uaPicker></mat-datepicker>

                    </mat-form-field>
                  </span>
                  <span *ngSwitchCase="'activeRole'"> {{element.activeRole}} </span>
                  <span *ngSwitchCase="'assignedDivision'"> {{element.activeStaffAssignment}} </span>
                </ng-container>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>

    <div class="nested-tabs-section" *ngIf="selectedData.length != 0">
      <div class="sub-tab-nav">
        <button class="sub-tab-btn" [class.active]="selectedTab === 'roleAssignments'"
          (click)="selectedTab = 'roleAssignments'">Role Assignments</button>
        <button class="sub-tab-btn" [class.active]="selectedTab === 'staffAssignments'"
          (click)="selectedTab = 'staffAssignments'">Staff Assignments</button>
        <button class="sub-tab-btn" [class.active]="selectedTab === 'staffAbsence'"
          (click)="selectedTab = 'staffAbsence'">Staff Absence</button>
      </div>


      <mat-tab-nav-panel #tabPanel>
        <div class="tab-content-area" *ngIf="selectedData.length != 0">

          <div class="section-header">
            <h3 class="heading">{{getLabelValue(selectedTab)}}</h3>
            <div class="action-toolbar">
              <button
                *ngIf="selectedTab==='roleAssignments'||selectedTab==='staffAssignments' || selectedTab==='staffAbsence'"
                mat-button color="primary" (click)="childTableAddFunction(selectedTab)"
                [disabled]="(!isAddMode && !isEdit) || (isEdit && selectedData.length === 0) || hasPendingChildEdits(selectedTab)">
                <mat-icon>add</mat-icon>
                Add
              </button>

              <button *ngIf="selectedTab==='staffAbsence'" mat-button color="primary"
                (click)="childTableModifyFunction(selectedTab)"
                [disabled]="!isEdit || !selectedAbsence || hasPendingChildEdits(selectedTab)">
                <mat-icon>edit</mat-icon>
                Modify
              </button>
            </div>
          </div>

          <div *ngIf="selectedTab === 'roleAssignments'" class="responsive-table-wrapper">
            <cdk-virtual-scroll-viewport itemSize="48" class="virtual-viewport sub-table-viewport">
              <table mat-table [dataSource]="roleAssignmentsData()" class="mat-elevation-z0">

                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef class="w-10"></th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox [checked]="selectedRoleAssignment===element"
                      [disabled]="isPastDate(element.roleEndDate)">
                    </mat-checkbox>
                  </td>
                </ng-container>

                <ng-container matColumnDef="role">
                  <th mat-header-cell *matHeaderCellDef>Role</th>
                  <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="!element.isEdit">{{ element.roleName }}</ng-container>
                    <mat-form-field *ngIf="element.isEdit" appearance="outline" class="dense-form-field"
                      style="margin-bottom: -1.25em;">
                      <mat-select [(ngModel)]="element.intRoleId"
                        (selectionChange)="onRoleChange($event.value, element)">
                        <mat-option *ngIf="element.roleName && !isRoleInList(element.roleName)"
                          [value]="element.roleName" style="display: none;">{{element.roleName}}</mat-option>
                        <mat-option *ngFor="let role of rolesList"
                          [value]="role.intRoleId">{{role.roleName}}</mat-option>
                      </mat-select>
                      <div matSuffix *ngIf="isRolesLoading"
                        style="margin-right: 8px; display: flex; align-items: center;">
                        <mat-spinner diameter="16"></mat-spinner>
                      </div>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="beginDate">
                  <th mat-header-cell *matHeaderCellDef>Begin Date</th>
                  <td mat-cell *matCellDef="let element">
                    <mat-form-field *ngIf="element.isEdit" appearance="outline" class="dense-form-field">
                      <input matInput [matDatepicker]="sd" [(ngModel)]="element.roleBeginDate"
                        [min]="element.minBeginDate" (dateChange)="onBeginDateChange($event, element)">
                      <mat-datepicker-toggle matSuffix [for]="sd"></mat-datepicker-toggle>
                      <mat-datepicker #sd></mat-datepicker>
                    </mat-form-field>
                    <span *ngIf="!element.isEdit">{{ element.roleBeginDate | date:'dd-MMM-yyyy' }}</span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="endDate">
                  <th mat-header-cell *matHeaderCellDef>End Date</th>
                  <td mat-cell *matCellDef="let r">
                    <span>{{ r.roleEndDate | date:'dd-MMM-yyyy' }}</span>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="['select', 'role', 'beginDate', 'endDate']; sticky: true">
                </tr>
                <tr mat-row *matRowDef="let row; columns: ['select', 'role', 'beginDate', 'endDate'];"></tr>
              </table>
            </cdk-virtual-scroll-viewport>
          </div>

          <div *ngIf="selectedTab === 'staffAssignments'" class="responsive-table-wrapper">
            <cdk-virtual-scroll-viewport itemSize="48" class="virtual-viewport sub-table-viewport">
              <table mat-table [dataSource]="staffAssignmentsData()" class="mat-elevation-z0">

                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef class="w-10"></th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox [checked]="selectedStaffAssignment===element"
                      [disabled]="isPastDate(element.roleEndDate)">
                    </mat-checkbox>
                  </td>
                </ng-container>

                <ng-container matColumnDef="courtDivision">
                  <th mat-header-cell *matHeaderCellDef>Court Division</th>
                  <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="!element.isEdit">{{ element.courtUnitName }}</ng-container>
                    <mat-form-field *ngIf="element.isEdit" appearance="outline" class="dense-form-field"
                      style="margin-bottom: -1.25em;">

                      <mat-select [(ngModel)]="element.selectedDivision"
                        (selectionChange)="onDivisionChange($event.value, element)">

                        <mat-option *ngIf="element.selectedDivision && !isDivisionInList(element.selectedDivision)"
                          [value]="element.selectedDivision" style="display: none;">
                          {{element.selectedDivision?.courtUnitTypeName}}
                        </mat-option>

                        <mat-option *ngFor="let div of divisionsList" [value]="div">
                          {{div.courtUnitTypeName}}
                        </mat-option>

                      </mat-select>

                      <div matSuffix *ngIf="isDivisionsLoading"
                        style="margin-right: 8px; display: flex; align-items: center;">
                        <mat-spinner diameter="16"></mat-spinner>
                      </div>

                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="courts">
                  <th mat-header-cell *matHeaderCellDef>Court (Readonly)</th>
                  <td mat-cell *matCellDef="let element" [class.blurred-row]="element.termination === 'D'">{{
                    element.courtsName }}</td>
                </ng-container>

                <ng-container matColumnDef="beginDate">
                  <th mat-header-cell *matHeaderCellDef>Begin Date</th>
                  <td mat-cell *matCellDef="let element">
                    <mat-form-field *ngIf="element.isEdit" appearance="outline" class="dense-form-field">
                      <input matInput [matDatepicker]="sd" [(ngModel)]="element.beginDate"
                        (dateChange)="onStaffAssignDateChange($event, element)">
                      <mat-datepicker-toggle matSuffix [for]="sd"></mat-datepicker-toggle>
                      <mat-datepicker #sd></mat-datepicker>
                    </mat-form-field>
                    <span *ngIf="!element.isEdit">{{ element.beginDate | date:'dd-MMM-yyyy' }}</span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="endDate">
                  <th mat-header-cell *matHeaderCellDef>End Date</th>
                  <td mat-cell *matCellDef="let r">
                    <span *ngIf="!r.isEdit">{{ r.endDate | date:'dd-MMM-yyyy' }}</span>
                  </td>
                </ng-container>

                <tr mat-header-row
                  *matHeaderRowDef="['select', 'courtDivision','courts', 'beginDate', 'endDate']; sticky: true">
                </tr>
                <tr mat-row *matRowDef="let row; columns: ['select', 'courtDivision','courts','beginDate', 'endDate'];">
                </tr>
              </table>
            </cdk-virtual-scroll-viewport>
          </div>
          <div *ngIf="selectedTab === 'staffAbsence'" class="responsive-table-wrapper">
            <cdk-virtual-scroll-viewport itemSize="48" class="virtual-viewport sub-table-viewport">
              <table mat-table [dataSource]="staffAbsencesData()" class="mat-elevation-z0">

                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef class="w-10"></th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox [checked]="selectedAbsence === element"
                      (change)="onAbsenceSelect($event.checked, element)" [disabled]="isPastDate(element.sabTo)">
                    </mat-checkbox>
                  </td>
                </ng-container>

                <ng-container matColumnDef="absenceType">
                  <th mat-header-cell *matHeaderCellDef>Absence Type</th>
                  <td mat-cell *matCellDef="let element" [class.blurred-row]="element.termination === 'D'">
                    <ng-container *ngIf="!element.isEdit">{{ element.absenceTypeName }}</ng-container>
                    <mat-form-field *ngIf="element.isEdit" appearance="outline" class="dense-form-field"
                      style="margin-bottom: -1.25em;">

                      <mat-select [(ngModel)]="element.selectedAbsenceType"
                        (selectionChange)="onAbsenceTypeChange($event.value, element)">

                        <mat-option
                          *ngIf="element.selectedAbsenceType && !isAbsenceTypeInList(element.selectedAbsenceType)"
                          [value]="element.selectedAbsenceType" style="display: none;">
                          {{element.selectedAbsenceType?.absenceTypeName}}
                        </mat-option>

                        <mat-option *ngFor="let absence of absenceTypesList" [value]="absence">
                          {{absence.absenceTypeName}}
                        </mat-option>

                      </mat-select>

                      <div matSuffix *ngIf="isAbsenceTypesLoading"
                        style="margin-right: 8px; display: flex; align-items: center;">
                        <mat-spinner diameter="16"></mat-spinner>
                      </div>

                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef>Description</th>
                  <td mat-cell *matCellDef="let element" [class.blurred-row]="element.termination === 'D'">{{
                    element.absenceTypeDesc }}</td>
                </ng-container>

                <ng-container matColumnDef="beginDate">
                  <th mat-header-cell *matHeaderCellDef>Begin Date</th>
                  <td mat-cell *matCellDef="let element">
                    <mat-form-field *ngIf="element.isEdit" appearance="outline" class="dense-form-field">
                      <input matInput [matDatepicker]="sd" [(ngModel)]="element.sabFrom"
                        (dateChange)="onFromDateChange($event.value, element)">
                      <mat-datepicker-toggle matSuffix [for]="sd"></mat-datepicker-toggle>
                      <mat-datepicker #sd></mat-datepicker>
                    </mat-form-field>
                    <span *ngIf="!element.isEdit">{{ element.sabFrom | date:'dd-MMM-yyyy' }}</span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="endDate">
                  <th mat-header-cell *matHeaderCellDef>End Date</th>
                  <td mat-cell *matCellDef="let r">
                    <mat-form-field *ngIf="r.isEdit" appearance="outline" class="dense-form-field">
                      <input matInput [matDatepicker]="ed" [(ngModel)]="r.sabTo"
                        (dateChange)="onToDateChange($event.value, r)">
                      <mat-datepicker-toggle matSuffix [for]="ed"></mat-datepicker-toggle>
                      <mat-datepicker #ed></mat-datepicker>
                    </mat-form-field>
                    <span *ngIf="!r.isEdit">{{ r.sabTo | date:'dd-MMM-yyyy' }}</span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="activeFlag">
                  <th mat-header-cell *matHeaderCellDef>Active Flag</th>
                  <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="!((element.isEdit || element.isModify) &&modifyStaffAbsence.length!==0)">{{
                      element.activeFlag }}</ng-container>
                    <mat-form-field *ngIf="((element.isEdit || element.isModify) && modifyStaffAbsence.length!==0)"
                      appearance="outline" class="dense-form-field" style="margin-bottom: -1.25em;">
                      <mat-select [(ngModel)]="element.activeFlag"
                        (selectionChange)="onActiveFlagChange($event.value, element)">
                        <mat-option value="Y">Y</mat-option>
                        <mat-option value="N">N</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                </ng-container>

                <tr mat-header-row
                  *matHeaderRowDef="['select', 'absenceType','description', 'beginDate', 'endDate','activeFlag']; sticky: true">
                </tr>
                <tr mat-row
                  *matRowDef="let row; columns: ['select', 'absenceType','description','beginDate', 'endDate','activeFlag'];">
                </tr>
              </table>
            </cdk-virtual-scroll-viewport>
          </div>
        </div>
      </mat-tab-nav-panel>
    </div>
  </div>
</div>